import { LanguageCode } from 'common/src/vtj/LanguageCode.enum'
import { UsageRegionReceiver } from 'todistukset-common/src/vtj/UsageRegionReceiver.enum'
import { UsageRegion } from 'todistukset-common/src/vtj/types/todistus'
import { isCountryInEUByCode } from 'todistukset-common/src/vtj/country.util'
import { EuCountries } from 'todistukset-common/src/vtj/EuCountries.enum'

export const checkIfTranslationIsAvailable = ({
  usageRegion,
  todistusLanguage,
}: {
  usageRegion: UsageRegion
  todistusLanguage?: LanguageCode | null
}): boolean => {
  if (
    todistusLanguage === LanguageCode.EN ||
    (usageRegion.receiver !== null &&
      usageRegion.receiver !== UsageRegionReceiver.TARGET_COUNTRY_AUTHORITY)
  ) {
    return false
  }

  const { countryKoodistoCode } = usageRegion
  return (
    !!countryKoodistoCode &&
    countryKoodistoCode !== EuCountries.FINLAND &&
    countryKoodistoCode !== EuCountries.SWEDEN &&
    isCountryInEUByCode(countryKoodistoCode)
  )
}
